var exports = {
  "nf": "x52a3aa3b--06518a--link",
  "Kk": "x52a3aa3b--06518a--icon",
  "Pt": "x52a3aa3b--06518a--icon--with-title",
  "DD": "x52a3aa3b--06518a--title",
};

module.exports = exports;
